<template>
  <v-toolbar class="white--text" color="primary">
    <v-icon color="white">{{ icon }}</v-icon>
    <span class="ml-2">{{ text }}</span>
    <span>
      <slot></slot>
    </span>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    icon: String,
    text: String,
  },
};
</script>

<style scoped>
.v-toolbar {
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
</style>
